import styled from 'styled-components';

import Button from '~atoms/Button';

type ContainerProps = {
    marginTop: number;
};
export const Container = styled.div<ContainerProps>`
    margin-top: ${({marginTop}) => marginTop}px;
`;

export const StyledButton = styled(Button)`
    padding: 12px 24px;
    height: 40px;
`;
